import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <p className="text-[7rem] md:text-[11rem] font-black text-background-300 select-none pointer-events-none leading-none">
        404
      </p>
      <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
        {t("notFound.title")}
      </h1>
      <p className="mt-3 text-base text-foreground-600 max-w-md">
        {t("notFound.description")}
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        <i className="ri-home-4-line w-5 h-5 flex items-center justify-center"></i>
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}